// extracted by mini-css-extract-plugin
export default {"head__container":"styles_head__container__z1tgN","head__title":"styles_head__title__Ybacd"};